import { render, staticRenderFns } from "./LocationActivityDetail.vue?vue&type=template&id=1c3c8dfe"
import script from "./LocationActivityDetail.vue?vue&type=script&lang=js"
export * from "./LocationActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports